import React, { useState } from "react";
import "./narrowPasswordField.css";
import eyeOpen from "../../assets/eyeOpen.png"; // Image for "show password"
import eyeClosed from "../../assets/eyeClosed.png"; // Image for "hide password"

const NarrowPasswordField = ({
  title,
  placeholder,
  isRequired,
  onChange,
  value,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div className="password-field-container">
      <label className="password-field-label">
        {title} {isRequired && <span className="required">*</span>}
      </label>
      <div className="password-input-wrapper">
        <input
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          required={isRequired}
          value={value}
          onChange={onChange}
          className="password-input"
        />
        <button
          type="button"
          onClick={toggleShowPassword}
          className="toggle-visibility-btn"
        >
          <img
            src={showPassword ? eyeClosed : eyeOpen}
            alt={showPassword ? "Hide password" : "Show password"}
            className="eye-icon"
          />
        </button>
      </div>
    </div>
  );
};

export default NarrowPasswordField;
